var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4863",
    "data-name": "Group 4863",
    xmlns: "http://www.w3.org/2000/svg",
    width: 644,
    height: 506.996,
    viewBox: "0 0 644 506.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M310.368,685.591a21.013,21.013,0,0,0,20.292-3.574c7.107-5.966,9.336-15.791,11.148-24.89l5.363-26.916-11.227,7.731c-8.075,5.56-16.33,11.3-21.921,19.35s-8.029,19.046-3.539,27.759",
    transform: "translate(-266.002 -220.326)",
    fill: "#042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M312.368,723.549c-1.413-10.3-2.867-20.724-1.873-31.129.881-9.241,3.7-18.266,9.44-25.669a42.7,42.7,0,0,1,10.956-9.928c1.1-.691,2.1,1.044,1.013,1.733a40.6,40.6,0,0,0-16.058,19.374c-3.5,8.892-4.057,18.585-3.455,28.03.364,5.712,1.137,11.387,1.914,17.054a1.04,1.04,0,0,1-.7,1.234,1.01,1.01,0,0,1-1.234-.7Z",
    transform: "translate(-266.268 -223.823)",
    fill: "#042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M324.424,712.151A15.469,15.469,0,0,0,337.9,719.11c6.825-.324,12.512-5.085,17.631-9.607l15.145-13.372-10.023-.48c-7.208-.345-14.6-.669-21.468,1.556s-13.2,7.573-14.452,14.679",
    transform: "translate(-268.153 -228.945)",
    fill: "#042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M308.08,735.826c6.8-12.038,14.694-25.416,28.794-29.692a32.131,32.131,0,0,1,12.111-1.25c1.286.111.965,2.093-.318,1.982a29.851,29.851,0,0,0-19.327,5.113c-5.45,3.709-9.693,8.867-13.284,14.335-2.2,3.35-4.17,6.842-6.141,10.329C309.285,737.758,307.443,736.953,308.08,735.826Z",
    transform: "translate(-265.975 -230.181)",
    fill: "#042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M877.592,514.925H502.517a4.365,4.365,0,0,1-4.359-4.359V162.243a4.365,4.365,0,0,1,4.359-4.359H877.592a4.365,4.365,0,0,1,4.359,4.359V510.564a4.364,4.364,0,0,1-4.359,4.359Z",
    transform: "translate(-291.121 -157.884)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141-2",
    "data-name": "Path 141",
    d: "M877.592,514.925H502.517a4.365,4.365,0,0,1-4.359-4.359V162.243a4.365,4.365,0,0,1,4.359-4.359H877.592a4.365,4.365,0,0,1,4.359,4.359V510.564a4.364,4.364,0,0,1-4.359,4.359Zm-375.076-355.3a2.619,2.619,0,0,0-2.613,2.613V510.564a2.619,2.619,0,0,0,2.613,2.613H877.592a2.618,2.618,0,0,0,2.613-2.613V162.243a2.619,2.619,0,0,0-2.613-2.613Z",
    transform: "translate(-291.121 -157.884)",
    fill: "#cacaca"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M706.959,262.185a2.96,2.96,0,0,0,0,5.919h162.4a2.96,2.96,0,1,0,0-5.919Z",
    transform: "translate(-318.333 -171.673)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M706.959,282.65a2.96,2.96,0,0,0,0,5.919h82.91a2.96,2.96,0,0,0,0-5.919Z",
    transform: "translate(-318.333 -174.378)",
    fill: "#e4e4e4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142-2",
    "data-name": "Path 142",
    d: "M543.391,392.7a2.96,2.96,0,0,0,0,5.919H847.9a2.96,2.96,0,0,0,0-5.919Z",
    transform: "translate(-296.709 -188.927)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143-2",
    "data-name": "Path 143",
    d: "M543.391,413.17a2.96,2.96,0,0,0,0,5.919H768.4a2.96,2.96,0,0,0,0-5.919Z",
    transform: "translate(-296.709 -191.633)",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142-3",
    "data-name": "Path 142",
    d: "M543.391,433.172a2.96,2.96,0,0,0,0,5.919H847.9a2.96,2.96,0,1,0,0-5.919Z",
    transform: "translate(-296.709 -194.277)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143-3",
    "data-name": "Path 143",
    d: "M543.391,453.637a2.96,2.96,0,0,0,0,5.919H768.4a2.96,2.96,0,1,0,0-5.919Z",
    transform: "translate(-296.709 -196.983)",
    fill: "#e4e4e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142-4",
    "data-name": "Path 142",
    d: "M543.391,474.172a2.96,2.96,0,0,0,0,5.919H847.9a2.96,2.96,0,0,0,0-5.919Z",
    transform: "translate(-296.709 -199.698)",
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143-4",
    "data-name": "Path 143",
    d: "M543.391,494.637a2.96,2.96,0,0,0,0,5.919H768.4a2.96,2.96,0,0,0,0-5.919Z",
    transform: "translate(-296.709 -202.403)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21288",
    "data-name": "Path 21288",
    d: "M592.942,311.872a42.522,42.522,0,1,1,42.522-42.522A42.522,42.522,0,0,1,592.942,311.872Z",
    transform: "translate(-298.03 -166.998)",
    fill: "#66b512"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21289",
    "data-name": "Path 21289",
    d: "M444.409,505.581a10.629,10.629,0,0,0-12.976-9.86l-14.055-19.808-14.12,5.605L423.5,509.212a10.686,10.686,0,0,0,20.91-3.631Z",
    transform: "translate(-278.575 -199.928)",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21290",
    "data-name": "Path 21290",
    d: "M412.633,489.865,370.1,434.693l15.935-50.082c1.168-12.591,9.047-16.107,9.382-16.251l.511-.219L409.8,405.119l-10.181,27.15,24.99,42.029Z",
    transform: "translate(-274.192 -185.68)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21291",
    "data-name": "Path 21291",
    d: "M585.12,312.406a10.628,10.628,0,0,0-8.827,13.7L557.631,341.65l6.68,13.645,26.046-22.322a10.686,10.686,0,0,0-5.237-20.567Z",
    transform: "translate(-298.983 -178.3)",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21292",
    "data-name": "Path 21292",
    d: "M571.771,342.387l-51.719,46.667-51.164-12.015c-12.644-.191-16.758-7.774-16.927-8.1l-.258-.493,35.8-16.684,27.856,8.052,39.971-28.164Z",
    transform: "translate(-284.979 -180.856)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21293",
    "data-name": "Path 21293",
    d: "M227.248,560.272h13.9l6.61-53.6H227.245Z",
    transform: "translate(-30.042 -66.983)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21294",
    "data-name": "Path 21294",
    d: "M0,0H43.673V16.874H12.253A12.253,12.253,0,0,1,0,4.621V0Z",
    transform: "translate(237.898 506.192) rotate(179.997)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21295",
    "data-name": "Path 21295",
    d: "M163.247,560.272h13.9l6.611-53.6H163.245Z",
    transform: "translate(-21.581 -66.983)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21296",
    "data-name": "Path 21296",
    d: "M0,0H43.673V16.874H12.253A12.252,12.252,0,0,1,0,4.621Z",
    transform: "translate(182.359 506.192) rotate(179.997)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21297",
    "data-name": "Path 21297",
    d: "M157.552,342.991l1.133,79.342,1.134,104.278,24.935-2.267L197.223,380.4l15.869,143.949h25.743l2.593-145.082-9.068-31.737Z",
    transform: "translate(-20.829 -45.344)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21298",
    "data-name": "Path 21298",
    d: "M462.562,489.168c-27.132,0-52.107-12.278-52.444-12.447l-.28-.14-2.277-54.642c-.66-1.931-13.661-40.032-15.863-52.143-2.231-12.27,30.1-23.038,34.029-24.3l.891-9.87,36.234-3.9,4.592,12.63,13,4.874a6.43,6.43,0,0,1,3.985,7.554l-7.225,29.38,17.645,97.2-3.8.164A68.984,68.984,0,0,1,462.562,489.168Z",
    transform: "translate(-277.032 -180.866)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 26.089,
    cy: 26.089,
    r: 26.089,
    transform: "translate(133.716 108.141) rotate(-28.663)",
    fill: "#a0616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21299",
    "data-name": "Path 21299",
    d: "M428.177,314.492c4.972,5.3,14.205,2.453,14.853-4.782a8.744,8.744,0,0,0-.011-1.688c-.334-3.2-2.186-6.115-1.743-9.5a4.981,4.981,0,0,1,.912-2.332c3.962-5.305,13.262,2.373,17-2.43,2.293-2.945-.4-7.582,1.357-10.873,2.322-4.344,9.2-2.2,13.514-4.58,4.8-2.647,4.512-10.01,1.353-14.489-3.853-5.462-10.608-8.376-17.278-8.8s-13.3,1.383-19.523,3.81c-7.076,2.758-14.093,6.569-18.447,12.79-5.3,7.566-5.805,17.739-3.157,26.587C418.619,303.593,424.117,310.168,428.177,314.492Z",
    transform: "translate(-280.186 -170.718)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21300",
    "data-name": "Path 21300",
    d: "M901.9,741.463H261.262c-.929,0-1.681-.336-1.681-.75s.753-.75,1.681-.75H901.9c.929,0,1.682.336,1.682.75S902.828,741.463,901.9,741.463Z",
    transform: "translate(-259.581 -234.835)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21301",
    "data-name": "Path 21301",
    d: "M593.991,289.515a3.027,3.027,0,0,1-2.066-.812L577.9,275.68a3.037,3.037,0,1,1,4.134-4.451l11.876,11.031,23.5-23.5a3.037,3.037,0,0,1,4.295,4.3l-25.566,25.566A3.031,3.031,0,0,1,593.991,289.515Z",
    transform: "translate(-301.535 -171.103)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqMan);
export default __webpack_public_path__ + "static/media/faq_man.b589d6121357b6b8ce6bbdff1a366ff4.svg";
export { ForwardRef as ReactComponent };